import * as React from 'react';

import './Table.scss';

interface Props {
  className?: string;
  type?: 'small' | 'dnd';
}

const Table: React.FC<Props> = ({ children, type = '', className }) => {
  return (
    <div className={`table ${type ? `table--${type}` : ''} ${className || ''}`}>
      <table>{children}</table>
    </div>
  );
};

export default Table;
